import cn from 'classnames';
import styles from './ButtonWithChildren.module.scss';
import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  color?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  buttonStyle?: string;
}

export const BUTTON_STYLES = {
  BASE: 'base',
  EMPTY: 'empty',
  FILLED: 'filled',
  DISABLED: 'disabled',
};

export const ButtonWithChildren = ({
  children,
  onClick,
  className,
  type = 'button',
  disabled,
  color,
  buttonStyle,
  onMouseEnter,
  onMouseLeave,
}: ButtonProps) => {
  return (
    <button
      type={type}
      className={cn(
        styles.buttonWithChildren,
        className,
        styles[`button--${color}`],
        buttonStyle === BUTTON_STYLES.EMPTY &&
          styles[`button--${BUTTON_STYLES.EMPTY}`],
        disabled && styles[`button--${BUTTON_STYLES.DISABLED}`]
      )}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </button>
  );
};
